import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "It took me ten months to write a video course",
  "description": "",
  "published": "2015-02-05T00:00:00.000Z",
  "redirect_from": ["/blog/it-took-me-ten-months-to-write-a-video-course/swizec/6651"],
  "categories": "Budapest, Business, d3js, Packt, Personal, Side Projects, Writing, Writing",
  "hero": "./img/images-26568.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/67d3fb9f0dedde8948a8e53093360ff5/20c85/images-26568.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "68.16143497757847%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'273\\'%20viewBox=\\'0%200%20400%20273\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20137v136h401V0H0v137m18%2011v114h368V34H18v114m85-87c-4%202-5%2010%200%2011%208%204%2013-7%205-11h-5m22%207v4c0%201%200%202-1%201l-4-3-4-2v7c0%207-3%2016-7%2023-2%204-3%209-2%209l1-1h1c-1%202%2026%2010%2029%209l3-8%203-10%202-5c-1-1%200-6%201-10l1-9-22-6-1%201m49%207l-2%202-9-2h-10c-2%202%200%209%202%2012%202%202%202%203%201%206s-1%203%201%203l2%204c1%203%202%204%204%204l7-1%2013%201%2016%202c2%200%202-1%203-12l1-13-8-1c-6%200-7-1-7-2%200-6-9-8-14-3m176%203l-1%206-1%206c-1%202%203%2014%204%2013l1-2%202-3%202-2%203-3c5-2%206-4%203-6-2-2-4-4-4-7-1-3-2-4-5-4l-4%202m-204%2076c0%202-1%203-2%203-1-1-2%201-2%206%201%204%200%208-1%207l-1%205-1%202c-2%201%2016%2011%2024%2012%204%201%203%203%206-23l1-3%201-4c0-3%200-4-2-4l-21-4-2%203m-27%2041l-4%203%201%202c3%204%202%204%200%203-3%200-3%200-3%202s0%202%203%202c1-1%202%200%202%201l-2%202-3%201c-1%202%200%206%202%206l1%202%203%201c2%200%202%200%201%203s0%202%203%200l2-3%201-2c0-2%202-3%202-3v2l-1%202%203-2c1-2%202-2%204-1h3c2%200%202-1%200-10l-2-10-5-1-6-1c-1-1-3%200-5%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/67d3fb9f0dedde8948a8e53093360ff5/ca0a1/images-26568.webp 223w", "/static/67d3fb9f0dedde8948a8e53093360ff5/75680/images-26568.webp 445w", "/static/67d3fb9f0dedde8948a8e53093360ff5/8d1ba/images-26568.webp 890w", "/static/67d3fb9f0dedde8948a8e53093360ff5/5375e/images-26568.webp 999w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/67d3fb9f0dedde8948a8e53093360ff5/e92b6/images-26568.png 223w", "/static/67d3fb9f0dedde8948a8e53093360ff5/e66bf/images-26568.png 445w", "/static/67d3fb9f0dedde8948a8e53093360ff5/4ef49/images-26568.png 890w", "/static/67d3fb9f0dedde8948a8e53093360ff5/20c85/images-26568.png 999w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/67d3fb9f0dedde8948a8e53093360ff5/4ef49/images-26568.png",
                "alt": "A responsive map",
                "title": "A responsive map",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`A responsive map`}</figcaption>{`
  `}</figure></p>
    <p>{`Last year my Write the Docs talk in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=47.4719444444,19.0502777778&spn=0.1,0.1&q=47.4719444444,19.0502777778%20(Budapest)&t=h",
        "title": "Budapest"
      }}>{`Budapest`}</a>{` concluded that publishers are the worst. I said they lure suckers in with chump change, then make large profits off their endless toil.`}</p>
    <p>{`But just a few weeks later I started a new project with my publisher, `}<a parentName="p" {...{
        "href": "http://www.packtpub.com",
        "title": "Packt"
      }}>{`Packt`}</a>{`. It wasn't a book this time, it was a d3.js video course.`}</p>
    <p>{`Why?`}</p>
    <p>{`Because why not. I've never made a video course before, but have strong opinions on why they suck. And trying out new media is fun.`}</p>
    <p>{`If I can make a course that doesn't need skimming and doesn't make you watch at 1.5x speed, I've won. I basically want to make a course that `}<em parentName="p">{`I would want to watch`}</em>{`.`}</p>
    <p>{`Well, here we are. Ten months later and the scripts portion is done. Deadlines have long since whooshed by, my editors have given up on keeping a schedule, and I think that officially we are 6 months behind the original estimate.`}</p>
    <p>{`They wanted to publish the course in October. It's February and I haven't started recording.`}</p>
    <p>{`Oops.`}</p>
    <p>{`Maybe I did dawdle. Just over 310 hours have gone into the writing of the scripts. An average of just an hour and a bit a day.`}</p>
    <p>{`Such lazy.`}</p>
    <p>{`Writing my d3.js book, `}<a parentName="p" {...{
        "href": "https://www.packtpub.com/web-development/data-visualization-d3js"
      }}>{`Data Visualization with d3.js`}</a>{`, the overall average ended up the same. But disregard the months of downtime between revisions, I invested three times as much daily effort into the book.`}</p>
    <p>{`I mean, let's be real here. Writing this video course I was so lazy and in such creative despair, that one time a higher up editor sent me an email saying `}<em parentName="p">{`"So err, dude, we haven't heard from you in like two months. Are you alive?"`}</em></p>
    <p>{`Yeah. That bad.`}</p>
    <p>{`But I got it the fuck done! The scripts are finished. They are 32,000 words long, and they are good. I think.`}</p>
    <p>{`As much time has gone just into writing the scripts as it did into the book start to publish. I'll be damned if I get another stinging review like this one:`}</p>
    <blockquote>
      <p parentName="blockquote">{`the content is weak and looks more like a me too, rushed approach.`}</p>
    </blockquote>
    <p>{`Seriously, screw you guy. That hurt. It was my first book and I slaved over that stupid thing for a year. Cut me some slack here!`}</p>
    <p>{`As for the scripts, my editor is encouraging:`}</p>
    <blockquote>
      <p parentName="blockquote">{`There isn't much feedback, the reviewers like the scripts as is(Can't say that I am surprised, your scripts were brilliant!)`}</p>
    </blockquote>
    <p>{`But there is an estimated 220 minutes of material there. Three and a half hours. They asked for two hours ... oops.`}</p>
    <p>{`Now I just hope my video recording and editing skills will be up to snuff. If this comes out as good as it looks in my head, it's going to be awesome.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      